import React from 'react'

function FaqText() {
  return (
<div className='long-form faq text-gray-200 font-garamond text-left text-lg'>
        <p><strong>FREQUENTLY ASKED QUESTIONS</strong></p>
        <p><strong>GENERAL QUESTIONS</strong></p>
        <p>Q: Who can enter the Secret Doors Contest?</p>
        <p><i>A: Any amateur writer who has never held a full-time job creating role-playing games is eligible to enter.
                        Freelancers with previously published work are welcome to participate.</i></p>
        <p>Q: Is there an age requirement to enter?</p>
        <p><i>A: Yes, you must be at least 18 years old to enter, or otherwise submit written parental consent.</i></p>
        <p>Q: Can I enter if I live outside the United States?</p>
        <p><i>A: Yes, the contest is open to international entrants. However, all submissions must be in</i>
                <i>English.</i>
        </p>
        <p>Q: When does the contest start and end?</p>
        <p><em>A:</em></p>
        <ul className='pl-6 text-lg mb-8'>
                <li><em>Contest Opens: April 13, 2025</em></li>
                <li><em>Submission Deadline: July 2, 2025</em></li>
                <li><em>Initial Voting Period: April 13 to July 2, 2025</em></li>
                <li><em>Final Voting Period: July 3, 2025 to July 17, 2025</em></li>
                <li><em>Winners Announced: July 18, 2025</em></li>
        </ul>
        <p>Q: How does the Secret Doors contest define an 'amateur' writer?</p>
        <p><i>A: The contest is only open to amateur writers, which we define as anyone who has never had a full-time
                        job
                        creating role-playing games. Having freelance work previously published does not disqualify you
                        from this
                        contest.</i></p>
        <p>Q: Do I give up any rights to my work to enter the Secret Doors Contest?</p>
        <p> <i>A: Yes, submissions become the property of Portals to Adventure. Participation is free.</i></p>
        <p>Q: Can I expect feedback on my submission?</p>
        <p><i>A: No, other than a rejection notice if your submission
                        violates our Code of Ethics.</i></p>
        <p>Q: If I win things in the Secret Doors Contest, when do I receive them?</p>
        <p> <i>A: Winners will receive their
                        pins, ribbons, trophies, and prize money within 30 days of the final winner announcement.</i>
        </p>
        <p>Q: What happens when you submit a Secret Door Adventure to PTA?</p>
        <p><i>A: When you submit a Secret Door adventure to PTA, and click that you agree to the contest rules, terms,
                        and
                        conditions, the PTA team will review it and post it for others to view and vote for it within 2
                        business
                        days. If, for some reason, the team finds something objectionable, you will receive a rejection
                        notice by
                        email.</i></p>

        <p>Q: How do I know if my Secret Door Adventure will be part of the PTA contest?</p>
        <p><i>A: All Secret Door Adventure submissions are reviewed and, upon approval, are queued up with all the other
                        submissions for fans to view and vote upon.</i></p>
        <p>Q: How do I upload a Secret Door Adventure to win money and publication?</p>
        <p><i>A: You can upload your Secret Door Adventure at our website here: www.portals-to-adventure.com. Copy text
                        into
                        the template and upload files as directed.</i></p>
        <p>Q: How long does it take to hear back from PTA after you submit a Secret Door Adventure?</p>
        <p><i>A: Approval will take no more than 2 business days after submission, at which time your submission is
                        queued
                        with all the others for fan viewing and voting. Disapproved submissions will receive an email
                        that briefly
                        explains the reason why.</i></p>
        <p>Q: What are the PTA submission rules?</p>
        <p><i>A: You can refer to the Official Contest Rules by clicking the Rules button.</i></p>
        <p>Q: What is the grand prize for winning the PTA Secret Doors contest?</p>
        <p><i>A: The grand prize for winning this Secret Doors Contest is 50% of the Prize Money Total, plus publication
                        as
                        part of the World's Largest Dungeon Platinum Edition.</i></p>
        <p><strong>SUBMISSION QUESTIONS</strong></p>
        <p>Q: Can I submit multiple entries?</p>
        <p><i>A: Yes, you may submit multiple unique Secret Door Adventures, but each must be a separate submission.</i>
        </p>
        <p>Q: Do I need to include a full dungeon, or just what's behind the secret door?</p>
        <p><i>A: Your submission should focus on what lies beyond the secret door—a room, a lair, a passage, or an
                        entire
                        mini-dungeon.</i></p>
        <p>Q: Can my Secret Door lead to an existing dungeon or setting from another game?</p>
        <p><i>A: No, all entries must be original content and cannot include copyrighted material or references to
                        existing
                        intellectual properties.</i></p>
        <p>Q: Can I include homebrew monsters, traps, or mechanics?</p>
        <p><i>A: Yes! As long as they comply with 5E SRD rules, you are encouraged to add unique features.</i></p>
        <p>Q: Do I need professional-quality maps and artwork?</p>
        <p><i>A: No. A hand-drawn map is acceptable as long as it clearly represents your dungeon layout.</i></p>
        <p>Q: How long can my video be?</p>
        <p><i>A: While shorter videos tend to be more engaging, you can make it as long as you like.</i></p>
        <p>Q: Can I update my submission after submitting it?</p>
        <p><i>A: No, once your entry is submitted and approved, it cannot be modified.</i></p>
        <p>Q: Can I submit a game in a language other than English?</p>
        <p> <i>A: Only games submitted in English will be
                        eligible for awards.</i></p>
        <p>Q: Can I use AI tools like Midjourney or Chat GPT?</p>
        <p> <i>A: No. The use of AI-generated content (text, images,
                        maps, or video scripts) is not allowed.</i></p>
        <p>Q: How long should my game draft document be and what should it contain?</p>
        <p> <i>A: Maximum length is 27,000
                        characters (which comes to about 4,500 words).</i></p>
        <p>Q: I don't have a map to submit! Will that be a problem?</p>
        <p> <i>A: All submission require a map, but even a
                        hand-drawn map will suffice.</i></p>
        <p>Q: I have art I would like to share as part of my Secret Door submission. How do I do that?</p>
        <p><i>A: The submission form has no place to add art, but you can certainly include art in your video so fans
                        can
                        see it there.</i></p>
        <p>Q: Regarding rules. What is in on/off the table?</p>
        <p> A:&nbsp;<i>This contest is specifically for SRD material and
                        must be presented for that game system.</i></p>
        <p>Q: Can I modify the rules as presented in the SRD document for my own game?</p>
        <p> <i>A: Yes. You are free to use
                        the SRD document as a springboard for your own creativity.</i></p>
        <p>Q: I've got an idea for a dungeon adventure that is very similar to an existing one. Is that allowed?</p>
        <p> <i>A:
                        Yes, but we encourage original ideas. Remember, fans will likely recognize similarity to an
                        existing setting
                        and be less likely to vote for it.</i></p>
        <p><strong>VOTING &amp; PRIZES</strong></p>
        <p>Q: How do fans vote for my entry?</p>
        <p><i>A: Fans can vote for submissions online during the voting periods. Each vote costs $1, with a maximum of
                        10
                        votes per voter per submission.</i></p>
        <p>Q: What happens if I make it to the Final Round?</p>
        <p><i>A: The top 20 vote-getters from the Initial Round advance to the Final Round. Votes reset to zero, and the
                        new
                        round of voting determines the winners.</i></p>
        <p>Q: Can I win multiple prizes if I submit multiple entries?</p>
        <p><i>A: Yes, if more than one of your submissions ranks in the top 10, each one is eligible for publication and
                        a
                        cash prize.</i></p>
        <p>Q: When will winners receive their prizes?</p>
        <p><i>A: Cash prizes, trophies, and publication confirmation will be distributed within 30 days of the contest's
                        conclusion.</i></p>
        <p>Q: Why must fans pay to vote?</p>
        <p><i>A: Paying to vote generates the prize money pool, and prevents bots from making zillions of votes; the
                        10-vote-per-submission limit prevents people from simply buying a victory.</i></p>
        <p>Q: Can I vote for my own submissions?</p>
        <p><i>A: Yes.</i></p>
        <p>Q: How much money do you win from PTA?</p>
        <p><em>A: After all the votes are tallied, the top ten vote-getters get published and a cash prize:</em></p>
        <ul className='pl-6 mb-8'>
                <li><i>Third- through Tenth-Place Winners = 5% of the Prize Money Total cash prize + publication</i></li>
                <li><i>Second-Place Winner = 10% of the Prize Money Total cash prize + publication</i></li>
                <li><i>First-Place Winner = 50% of the Prize Money Total cash prize + publication</i></li>
        </ul>
        <p>Q: How are winners chosen?</p>
        <p><i>A: Winners are chosen by fan votes only. Fans can view all the submitted Secret Door Adventures and then
                        vote
                        for them online for the duration of the contest.</i></p>
        <p><strong>CONDUCT &amp; FAIR PLAY</strong></p>
        <p>Q: What happens if I break the contest rules?</p>
        <p><i>A: Violating contest rules or the Code of Ethics may result in disqualification and potential bans from
                        future
                        contests.</i></p>
        <p>Q: Can I promote my entry on social media?</p>
        <p><i>A: Yes! We encourage contestants to promote their submission on social media, forums, and personal
                        networks.</i></p>
        <p>Q: Can I pay people to vote for me?</p>
        <p><i>A: No. Vote-buying, automated voting, and fraudulent activity will result in disqualification.</i></p>
        <p>Q: What if I suspect someone is cheating?</p>
        <p><i>A: Report any suspected misconduct to <a className='hover:underline hover:text-cyan-600' href="mailto:contact@portals-to-adventure.com">contact@portals-to-adventure.com</a>.</i></p>
        <p><strong>TECHNICAL &amp; OTHER QUESTIONS</strong></p>
        <p>Q: What file formats are accepted for submissions?</p>
        <p><i>A: Text should be copied into the submission form. Maps and thumbnails must be JPEG, PNG, or PDF. Videos
                        must
                        be uploaded to YouTube or a similar platform and shared as a link.</i></p>
        <p>Q: I submitted my entry, but I haven't received confirmation. What should I do?</p>
        <p><i>A: You should see your entry as approved, or a rejection email, within 2 business days. If not, check your
                        spam folder or contact us.</i></p>
        <p>Q: Where can I see past winners?</p>
        <p><i>A: A Hall of Fame for past contest winners will be available on our website.</i></p>
        <p>Further questions? Contact us at <a className='hover:underline hover:text-cyan-600' href="mailto:contact@portals-to-adventure.com">contact@portals-to-adventure.com</a> </p>
</div>
  )
}

export default FaqText

